import { AppRoute } from '@agentselly/immodossier-shared';
import { cockpitStatisticsWidgets } from '~/config/widgets/cockpit/cockpitStatisticsWidgets';
import { makeQueryLoaderWidgetsRoute } from '~/helper/makeQueryLoaderWidgetsRoute';

export const Route = makeQueryLoaderWidgetsRoute(
  AppRoute.$LANG_$COMPANYID_PUBLIC_DEMO_COCKPIT_STATISTICS,
  cockpitStatisticsWidgets,
  true,
);
